
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M12 3.625c.446 0 .814.334.868.765l.007.11.001.68a6.879 6.879 0 015.944 5.945h.68a.875.875 0 01.11 1.743l-.11.007h-.68a6.879 6.879 0 01-5.945 5.945v.68a.875.875 0 01-1.743.11l-.007-.11-.001-.68a6.879 6.879 0 01-5.944-5.944l-.68-.001a.875.875 0 01-.11-1.743l.11-.007h.68a6.879 6.879 0 015.945-5.945V4.5c0-.483.392-.875.875-.875zm0 3.25a5.125 5.125 0 100 10.25 5.125 5.125 0 000-10.25zM12 9.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"}})])
          )
        }
      }
    